var _path, _path2, _mask, _path3, _path4, _path5, _path6, _path7, _path8, _mask2, _path9, _path10, _path11, _mask3, _path12, _path13, _path14, _path15, _mask4, _path16, _path17, _path18, _path19, _mask5, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJdDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 193,
    viewBox: "0 0 130 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1637 135.366L79.743 112.405C80.9944 111.679 82.5381 111.676 83.7926 112.396L123.642 135.285C126.346 136.839 126.354 140.737 123.655 142.301L83.8002 165.401C82.542 166.13 80.9894 166.128 79.7324 165.397L40.1592 142.37C37.473 140.807 37.4755 136.926 40.1637 135.366Z",
    fill: "#394854",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6091 134.017L79.7289 111.068C80.9888 110.329 82.5491 110.326 83.8122 111.06L123.198 133.936C125.88 135.493 125.888 139.364 123.212 140.932L83.8198 164.018C82.553 164.76 80.9837 164.759 79.7182 164.014L40.6046 141.001C37.9409 139.434 37.9435 135.581 40.6091 134.017Z",
    fill: "#C4E9FD",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2617_3341",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9341 110.987H125.915V138.347H37.9341V110.987Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9341 110.987H125.915V138.347H37.9341V110.987Z",
    fill: "#C4E9FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.195 110.987V138.347H126.635V110.987H125.195ZM38.6541 138.347V110.987H37.2141V138.347H38.6541Z",
    fill: "#394854",
    mask: "url(#path-3-inside-1_2617_3341)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1637 107.444L79.743 84.482C80.9944 83.756 82.5381 83.7527 83.7926 84.4733L123.642 107.362C126.346 108.916 126.354 112.814 123.655 114.378L83.8002 137.478C82.542 138.207 80.9894 138.206 79.7324 137.474L40.1592 114.447C37.473 112.884 37.4755 109.003 40.1637 107.444Z",
    fill: "#C4E9FD",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1637 106.712L79.743 83.7506C80.9944 83.0246 82.5381 83.0213 83.7926 83.7418L123.642 106.631C126.346 108.184 126.354 112.083 123.655 113.647L83.8002 136.746C82.542 137.475 80.9894 137.474 79.7324 136.743L40.1592 113.716C37.473 112.153 37.4755 108.272 40.1637 106.712Z",
    fill: "#C4E9FD",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1161 168.172L36.2262 150.029C37.2184 149.45 38.4445 149.448 39.4392 150.022L70.7613 168.107C72.8903 169.337 72.8963 172.407 70.7721 173.645L39.4452 191.896C38.4476 192.478 37.2144 192.477 36.2178 191.894L5.1125 173.699C2.99788 172.463 2.99987 169.406 5.1161 168.172Z",
    fill: "#394854",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1161 166.786L36.2262 148.644C37.2184 148.065 38.4445 148.062 39.4392 148.637L70.7613 166.722C72.8903 167.951 72.8963 171.022 70.7721 172.26L39.4452 190.511C38.4476 191.092 37.2144 191.091 36.2178 190.508L5.1125 172.314C2.99788 171.077 2.99987 168.02 5.1161 166.786Z",
    fill: "#C4E9FD",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-2_2617_3341",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16113 147.402H72.6962V169.471H3.16113V147.402Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16113 147.402H72.6962V169.471H3.16113V147.402Z",
    fill: "#C4E9FD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9762 147.402V169.471H73.4162V147.402H71.9762ZM3.88113 169.471V147.402H2.44113V169.471H3.88113Z",
    fill: "#394854",
    mask: "url(#path-9-inside-2_2617_3341)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92398 144.023L36.205 125.876C37.1941 125.302 38.414 125.3 39.4055 125.869L70.8998 143.959C73.0371 145.187 73.0431 148.268 70.9106 149.504L39.4115 167.76C38.4171 168.337 37.1901 168.336 36.1967 167.758L4.92038 149.559C2.79739 148.323 2.79939 145.256 4.92398 144.023Z",
    fill: "white",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-3_2617_3341",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9341 83.0645H125.915V110.987H37.9341V83.0645Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9341 83.0645H125.915V110.987H37.9341V83.0645Z",
    fill: "#C4E9FD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.195 83.0645V110.987H126.635V83.0645H125.195ZM38.6541 110.987V83.0645H37.2141V110.987H38.6541Z",
    fill: "#394854",
    mask: "url(#path-12-inside-3_2617_3341)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1637 79.7695L79.743 56.808C80.9944 56.082 82.5381 56.0786 83.7926 56.7992L123.642 79.6883C126.346 81.2416 126.354 85.1403 123.655 86.7042L83.8002 109.804C82.542 110.533 80.9894 110.531 79.7324 109.8L40.1592 86.7732C37.473 85.2101 37.4755 81.329 40.1637 79.7695Z",
    fill: "#C4E9FD",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1637 79.0381L79.743 56.0765C80.9944 55.3505 82.5381 55.3472 83.7926 56.0678L123.642 78.9568C126.346 80.5102 126.354 84.4089 123.655 85.9727L83.8002 109.072C82.542 109.801 80.9894 109.8 79.7324 109.069L40.1592 86.0417C37.473 84.4787 37.4755 80.5976 40.1637 79.0381Z",
    fill: "#C4E9FD",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-4_2617_3341",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9341 55.3901H125.915V83.313H37.9341V55.3901Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9341 55.3901H125.915V83.313H37.9341V55.3901Z",
    fill: "#C4E9FD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.195 55.3901V83.313H126.635V55.3901H125.195ZM38.6541 83.313V55.3901H37.2141V83.313H38.6541Z",
    fill: "#394854",
    mask: "url(#path-16-inside-4_2617_3341)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1642 50.9565L79.7435 27.995C80.9949 27.269 82.5385 27.2656 83.7931 27.9862L123.642 50.8753C126.346 52.4286 126.354 56.3273 123.656 57.8912L83.8007 80.9906C82.5425 81.7198 80.9899 81.7185 79.7329 80.9871L40.1596 57.9602C37.4735 56.3972 37.476 52.516 40.1642 50.9565Z",
    fill: "#C4E9FD",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1642 50.3711L79.7435 27.4095C80.9949 26.6835 82.5385 26.6802 83.7931 27.4008L123.642 50.2898C126.346 51.8432 126.354 55.7419 123.656 57.3057L83.8007 80.4052C82.5425 81.1344 80.9899 81.1331 79.7329 80.4017L40.1596 57.3747C37.4735 55.8117 37.476 51.9306 40.1642 50.3711Z",
    fill: "#C4E9FD",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-5_2617_3341",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9341 27.4673H125.915V55.3901H37.9341V27.4673Z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9341 27.4673H125.915V55.3901H37.9341V27.4673Z",
    fill: "#C4E9FD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M125.195 27.4673V55.3901H126.635V27.4673H125.195ZM38.6541 55.3901V27.4673H37.2141V55.3901H38.6541Z",
    fill: "#394854",
    mask: "url(#path-20-inside-5_2617_3341)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1436 47.799C44.1436 48.7856 44.8392 49.9877 45.6982 50.4842C46.5573 50.9806 47.2529 50.5832 47.2529 49.5967C47.2529 48.6101 46.5573 47.408 45.6982 46.9116C44.8392 46.4151 44.1436 46.8125 44.1436 47.799Z",
    fill: "#FFEBAF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1436 77.1613C44.1436 78.1479 44.8392 79.35 45.6982 79.8465C46.5573 80.3429 47.2529 79.9455 47.2529 78.959C47.2529 77.9724 46.5573 76.7703 45.6982 76.2739C44.8392 75.7774 44.1436 76.1748 44.1436 77.1613Z",
    fill: "#FFEBAF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1436 106.524C44.1436 107.51 44.8392 108.712 45.6982 109.209C46.5573 109.705 47.2529 109.308 47.2529 108.321C47.2529 107.335 46.5573 106.133 45.6982 105.636C44.8392 105.14 44.1436 105.537 44.1436 106.524Z",
    fill: "#FFEBAF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52002 161.684C7.52002 162.67 8.21567 163.872 9.07469 164.369C9.93372 164.865 10.6294 164.468 10.6294 163.481C10.6294 162.495 9.93372 161.293 9.07469 160.796C8.21567 160.3 7.52002 160.697 7.52002 161.684Z",
    fill: "#FFEBAF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4326 51.9087C50.4326 52.8952 51.1283 54.0973 51.9873 54.5938C52.8463 55.0902 53.542 54.6929 53.542 53.7063C53.542 52.7197 52.8463 51.5176 51.9873 51.0212C51.1283 50.5247 50.4326 50.9221 50.4326 51.9087Z",
    fill: "#FFEBAF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4326 81.271C50.4326 82.2575 51.1283 83.4596 51.9873 83.9561C52.8463 84.4525 53.542 84.0552 53.542 83.0686C53.542 82.082 52.8463 80.8799 51.9873 80.3835C51.1283 79.887 50.4326 80.2844 50.4326 81.271Z",
    fill: "#FFEBAF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4326 110.633C50.4326 111.62 51.1283 112.822 51.9873 113.318C52.8463 113.815 53.542 113.417 53.542 112.431C53.542 111.444 52.8463 110.242 51.9873 109.746C51.1283 109.249 50.4326 109.647 50.4326 110.633Z",
    fill: "#FFEBAF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8091 165.793C13.8091 166.78 14.5047 167.982 15.3638 168.479C16.2228 168.975 16.9184 168.578 16.9184 167.591C16.9184 166.605 16.2228 165.402 15.3638 164.906C14.5047 164.41 13.8091 164.807 13.8091 165.793Z",
    fill: "#FFEBAF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1637 25.1396L79.743 2.17807C80.9944 1.45208 82.5381 1.44875 83.7926 2.16934L123.642 25.0584C126.346 26.6117 126.354 30.5104 123.655 32.0743L83.8002 55.1737C82.542 55.9029 80.9894 55.9016 79.7324 55.1702L40.1592 32.1433C37.473 30.5803 37.4755 26.6992 40.1637 25.1396Z",
    fill: "#C4E9FD",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1637 24.1726L79.743 1.21103C80.9944 0.485043 82.5381 0.481714 83.7926 1.2023L123.642 24.0913C126.346 25.6447 126.354 29.5434 123.655 31.1072L83.8002 54.2067C82.542 54.9359 80.9894 54.9346 79.7324 54.2032L40.1592 31.1762C37.473 29.6132 37.4755 25.7321 40.1637 24.1726Z",
    fill: "#394854",
    stroke: "#394854",
    strokeWidth: 0.72
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6328 61.1903V57.8667L95.5323 52.8076V56.1681L86.6328 61.1903Z",
    fill: "#394854"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6328 89.4366V86.113L95.5323 81.054V84.4144L86.6328 89.4366Z",
    fill: "#394854"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6328 117.683V114.359L95.5323 109.3V112.661L86.6328 117.683Z",
    fill: "#394854"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6328 145.929V142.606L95.5323 137.547V140.907L86.6328 145.929Z",
    fill: "#394854"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5552 174.696V171.373L51.4547 166.314V169.674L42.5552 174.696Z",
    fill: "#394854"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7114 55.0397V51.7161L106.611 46.657V50.0174L97.7114 55.0397Z",
    fill: "#394854"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7114 83.286V79.9624L106.611 74.9033V78.2638L97.7114 83.286Z",
    fill: "#394854"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7114 111.532V108.209L106.611 103.15V106.51L97.7114 111.532Z",
    fill: "#394854"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7114 139.779V136.455L106.611 131.396V134.756L97.7114 139.779Z",
    fill: "#394854"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6343 168.546V165.222L62.5338 160.163V163.524L53.6343 168.546Z",
    fill: "#394854"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M67.395 64.4268L60.8241 68.2668C58.3388 69.7192 56.811 72.3815 56.811 75.2601V138.298",
    stroke: "#394854",
    strokeWidth: 1.35,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8369 58.489L51.266 62.329C48.7807 63.7814 47.2529 66.4438 47.2529 69.3224L47.253 132.771",
    stroke: "#394854",
    strokeWidth: 1.35,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJdDe);
export default __webpack_public_path__ + "static/media/jd-de.ca0105f8476679f2327dc3c84f870283.svg";
export { ForwardRef as ReactComponent };